var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 2.5,
    fill: "#E9ECEE",
    fillOpacity: 0.6,
    stroke: "#5EBB47",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16L14 21.5L24 11",
    stroke: "#DADADA",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.3b597ad3ef1d4b4a9b5fd2ba2ca20218.svg";
export { ForwardRef as ReactComponent };